export function convertNanoToMilliSeconds(valueNs: number): number {
  return valueNs * 1e-6
}

export function convertMilliToSeconds(valueMs: number): number {
  return valueMs * 1e-3
}
